import { EmptyStatePlaceholder } from '@dreryk/react-components';

import { issuedInvoicesTranslationKeys } from '../../translations';

export const IssuedInvoicesTableEmptyStatePlaceholder = (): JSX.Element => {
   return (
      <EmptyStatePlaceholder
         heading={issuedInvoicesTranslationKeys.table.emptyStatePlaceholder.heading}
         testId={'noIssuedInvoices'}
         subheading={issuedInvoicesTranslationKeys.table.emptyStatePlaceholder.subheading}
      />
   );
};
